import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { BackAndMultipleButtons, ContinueButton, ContinueWithBackButtons, SaveTempButton } from 'components/base/BottomStepComponent';
import { CREATE_CAMPAIGN_COUPON_PAGE_CONFIG } from 'containers/engagement/campaignStreamline/CreateCampaignCouponPageConfig';

import '../campaign/campaignCreation/CouponCampaignSection.scss';
import './CreateCampaignCouponPage.scss';


import CouponGeneralBrand from '../../assets/images/coupon/preview/SingleCoupon_brand.png';
import CouponDefaultPreview from '../../assets/images/coupon/preview/SingleCoupon_default.png';
import CouponDetailContent from '../../assets/images/coupon/preview/SingleCoupon_detailContent.png';
import CouponDetailTitle from '../../assets/images/coupon/preview/SingleCoupon_detailTitle.png';
import CouponKeyVisualImage from '../../assets/images/coupon/preview/SingleCoupon_image.png';
import CouponInstructionContent from '../../assets/images/coupon/preview/SingleCoupon_instructionContent.png';
import CouponInstructionTitle from '../../assets/images/coupon/preview/SingleCoupon_instructionTitle.png';
import CouponGeneralStore from '../../assets/images/coupon/preview/SingleCoupon_store.png';
import CouponGeneralName from '../../assets/images/coupon/preview/SingleCoupon_title.png';
import { scrollToAnchor } from './CreateCampaignHandleError';
import RequireCampaignNamePrompt from './RequireCampaignNamePrompt';
import { ActionType, APIStatus, CampaignType } from 'config/CustomEnums';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';

const inputWithImageConfig = {
  name: CouponGeneralName,
  relatedBrand: CouponGeneralBrand,
  selectedStores: CouponGeneralStore,
  coverPhoto: CouponKeyVisualImage,
  otherPhotos: CouponKeyVisualImage,
  instructionTitle: CouponInstructionTitle,
  instructionContent: CouponInstructionContent,
  detailsTitle: CouponDetailTitle,
  detailsContent: CouponDetailContent,
};
const defaultImage = CouponDefaultPreview;

const CreateCampaignCouponPage = ({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
}) => {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    formState: { errors },
    getValues,
  } = useFormContext();

  const watchName = getValues('translations.en.generalName');
  const campaignType = getValues('campaignType');
  const [showRequireNamePrompt, setShowRequireNamePrompt] = useState(false);
  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  const errorLanguage = Object.keys(errors?.translations || [])?.[0];
  const [fieldsError, setFieldsError] = useState(Object.keys(errors || []).length);

  const saveDraftAction = () => {
    dispatch({
      type: 'createCampaign/createOrUpdateCampaignV2',
      payload: {
        data: getValues(),
        actionType: ActionType.save,
        resume: location.state?.resume,
      }
    });
  };

  useEffect(() => {
    if (createStatus === APIStatus.success && formHasSubmitted) {
      setShowPublishPrompt(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus, formHasSubmitted]);


  useEffect(() => {
    setFieldsError(Object.keys(errors || []).length);
  }, [errors]);

  useEffect(() => {
    scrollToAnchor(anchorKey, sectionKey);
  }, [anchorKey, sectionKey]);

  const stepChangeAction = (step) => {
    setFieldsError(0);
    dispatch({
      type: 'campaignStreamline/stepChange',
      payload: { step: step },
    });
  };

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATE_CAMPAIGN_COUPON_PAGE_CONFIG}
        hidePreview={false}
        fieldsError={fieldsError}
        errorLanguage={errorLanguage}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
        sectionStyle='create-campaign-streamline-step-2'
      />
      <BackAndMultipleButtons
        backAction={() => stepChangeAction(2)}
        multipleButtons={[
          ...(
            params.id
              ? []
              : [
                <SaveTempButton
                  text="Save as draft"
                  action={() => {
                    if (!watchName) {
                      setShowRequireNamePrompt(true);
                      return;
                    };
                    saveDraftAction();
                  }}
                />
              ]
          ),
          <ContinueButton
            text="Continue"
            action={() => {
              stepChangeAction(4);
            }}
          />,
        ]}
      />
      <RequireCampaignNamePrompt
        show={showRequireNamePrompt}
        onHide={() => {
          setShowRequireNamePrompt(false);
        }}
        onConfirm={() => {
          setShowRequireNamePrompt(false);
          saveDraftAction();
        }}
      />
      <PublishCampaignPrompt
        campaignId={params.id}
        campaignType={campaignType}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/campaigns'}
      />
    </>
  );
}
const mapStateToProps = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
});
export default connect(mapStateToProps)(CreateCampaignCouponPage);

